import ServerError from './server-error';

export default async (res: Response): Promise<Response> => {
  if (!res.ok || res.status >= 400) {
    const contentType = res.headers.get('Content-Type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      const data = await res.json();
      if ('message' in data) {
        throw new ServerError(res.status, data.message);
      }
    } else {
      throw new ServerError(res.status, await res.text());
    }
  }

  return res;
};
